'use client';

import CustomLink from 'components/shared/CustomLink';
import { useSearchParams } from 'next/navigation';
import React from 'react';
import { CaretUp, Check, Cross } from 'assets/icons';
import { Layout } from 'components/ring-claim/Layout';
import styles from './success.module.css';

export const OrderStatus = () => {

  const searchParams = useSearchParams();
  const status = searchParams?.get('status');
  const message = searchParams?.get('message');

  return (
    <div className={styles.root}>
      <Layout>
        {status == 'error' ? (
          <>
            <div style={{ textAlign: 'left' }}>
              <CustomLink
                href="/gift-card/redeem"
                style={{ fontSize: '1.7rem' }}
              >
                <>
                  <CaretUp
                    style={{
                      transform: 'rotate(-90deg)',
                      width: '1.2rem',
                      marginRight: '8px',
                    }}
                  />
                  Back{' '}
                </>
              </CustomLink>
            </div>
            <div style={{ textAlign: 'center' }}>
              <Cross />
            </div>
          </>
        ) : (
          <div style={{ textAlign: 'center' }}>
            <Check />
          </div>
        )}
        <h1>
          {status == 'error' ? message : 'Your Ring AIR order is confirmed'}
        </h1>
        {status === 'success' ? (
          <p>
            You’ve successfully redeemed your Ring AIR Gift Card. We’ll email
            your order tracking details.{' '}
          </p>
        ) : null}
      </Layout>
    </div>
  );
};

export default OrderStatus;
